import { CascadiaButtonProps } from "@certn/cascadia/components/button/types";
import { AriaButtonProps } from "react-aria";

import { _Button, ButtonProps } from "./_Button";

interface Props extends CascadiaButtonProps {
  iconType?: ButtonProps["iconType"];
  buttonRef?: ButtonProps["buttonRef"];
  /** @deprecated Use LinkButton instead. */
  href?: AriaButtonProps["href"];
  inverse?: boolean;
  className?: string;
}

/** @deprecated Please update import to `@certn/cascadia` to add cross-platform support. See CHEESE-213 for more details. */
export function BasicButton(props: Props) {
  const { testID = "basic-button", inverse, className } = props;

  return (
    <_Button
      border="border-button"
      color={inverse ? "text-inverse" : "text-base"}
      fill={inverse ? "background-inverse" : "background-base"}
      focusStyle="focus-action"
      hoverFill={
        inverse ? "background-inverse" : "background-accent-neutral-weak"
      }
      iconColor={inverse ? "icon-inverse" : "icon-base"}
      shadow="shadow-button"
      loaderColor="icon-success"
      testID={testID}
      className={className}
      {...props}
    />
  );
}
